import { memo } from "react";
import { generatePath } from "react-router";

import { cn } from "@/lib/chillnn/cn";
import type { HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { StepHeader } from "../_step-header";
import { TodoListSectionItem } from "../_todo-list-section-item";
import { TodoListSectionWrapper } from "../_todo-list-section-wrapper";
import { TodoListWrapper } from "../_todo-list-wrapper";

type Props = {
	startGuide: HotelTopQuery["startGuide"];
	disabled: boolean;
};

const HOTEL_POLICY_NOT_REGISTERED_MESSAGE = "ホテルポリシーの設定をしてください";
const ROOM_NOT_REGISTERED_MESSAGE = "部屋情報の登録をしてください";

export const Step2 = memo(
	({
		startGuide: {
			hotelID,
			isHotelPolicyRegistered,
			isRoomRegistered,
			isRoomPriceRankRegistered,
			isSiteControllerRegistered,
			isShowRoomPriceRank,
		},
		disabled,
	}: Props) => {
		return (
			<div className={cn("space-y-4", disabled && "pointer-events-none opacity-30")}>
				<StepHeader title="Step2" description="部屋情報と部屋料金の登録" />

				<TodoListWrapper>
					<TodoListSectionWrapper>
						<TodoListSectionItem
							title={"部屋情報登録"}
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.HOTEL.ITEMS.ROOM.TOP, { hotelID })}
							checkBoxStatus={isRoomRegistered}
							requiredTime={10}
							showCheckBox={true}
						/>
						<TodoListSectionItem
							title={"料金・在庫の管理方法の設定（サイトコントローラー）"}
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.SETTINGS.SITE_CONTROLLER, { hotelID })}
							checkBoxStatus={isSiteControllerRegistered}
							requiredTime={5}
							showCheckBox={true}
						/>
						{isShowRoomPriceRank && (
							<TodoListSectionItem
								title={"部屋の料金設定"}
								transitionCondition={isHotelPolicyRegistered && isRoomRegistered}
								alertMessageWhenNotTransition={
									isHotelPolicyRegistered
										? ROOM_NOT_REGISTERED_MESSAGE
										: HOTEL_POLICY_NOT_REGISTERED_MESSAGE
								}
								pagePath={generatePath(PATHS.HOTEL.ITEMS.ROOM.PRICE_RANK, { hotelID })}
								checkBoxStatus={isRoomPriceRankRegistered}
								requiredTime={10}
								showCheckBox={true}
							/>
						)}
					</TodoListSectionWrapper>
				</TodoListWrapper>
			</div>
		);
	},
);

Step2.displayName = "Step2";
